import { sendLog } from "../api/LogsRequest";

export const logVisitorConnectionDetails = (userDetails) => {
    const options = {method: 'GET'};
    const fields = "&fields=ip_address,city,region,region_iso_code,postal_code,country,country_code,continent"
    
    if (userDetails) {
      const {activity, userId, username, page} = userDetails;
      var logDetails = {
          activity,
          category: 'interaction',
          page,
          userId: userId,
          data: {
              userId,
              username
          }
      }      
    } else {
        logDetails = {
          activity: "visit",
          category: 'interaction',
        }
    }
    
    fetch(process.env.REACT_APP_ABSTRACT_URL + fields, options)
    .then(response => {
      logDetails.response = response.status       
      return response.json();
    })
    .then(response => {
      if (logDetails.response !== 200) {
        logDetails.data = {...logDetails.data, ...response.error};
        logDetails.status = 'failure'
      } else {
        logDetails.data = {...logDetails.data, ...response};
        logDetails.status = 'success'
      }
      sendLog(JSON.stringify(logDetails));
    })
    .catch(err => console.error(err));
  }